export default __webpack_public_path__ + "static/media/exit.2169def8.svg";